import React, { ChangeEvent, useEffect, useState } from 'react';
import { Instance } from '../model/Instance';
import { BillingPeriod } from '../model/BillingPeriod';
import { InstanceSettings } from '../model/InstanceSettings';

const InstanceForm = ({ instance, settings, onSave, onCancel }: Props) => {
  const [name, setName] = useState(instance.name);
  const [description, setDescription] = useState(instance.description || '');
  const [apiKey, setApiKey] = useState(instance.apiKey || '');
  const [billingPeriod, setBillingPeriod] = useState<string>(BillingPeriod.YEARLY);

  useEffect(() => {
    setName(instance.name || '');
    setDescription(instance.description || '');
    setApiKey(instance.apiKey || '');
  }, [ instance ]);

  useEffect(() => {
    setBillingPeriod(settings?.billingPeriod || BillingPeriod.YEARLY);
  }, [ settings ]);

  const onChangeName = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  }

  const onChangeDescription = (event: ChangeEvent<HTMLInputElement>) => {
    setDescription(event.target.value);
  }

  const onChangeApiKey = (event: ChangeEvent<HTMLInputElement>) => {
    setApiKey(event.target.value);
  }

  const onChangeBillingPeriod = (event: ChangeEvent<HTMLSelectElement>) => {
    setBillingPeriod(event.target.value);
  }

  const onSaveItem = () => {
    const i = { ...instance, name, description, apiKey };
    const s = { ...settings, billingPeriod: billingPeriod as BillingPeriod };
    onSave(i, s);
  }

  const disabled = () => {
    return !name || !description || !apiKey;
  }

  return (
    <div>
      <div className="mb-3">
        <label className="form-label">Name</label>
        <input type="text" className="form-control" value={name} onChange={onChangeName} />
      </div>
      <div className="mb-3">
        <label className="form-label">Description</label>
        <input type="text" className="form-control" value={description} onChange={onChangeDescription} />
      </div>
      <div className="mb-3">
        <label className="form-label">API Key</label>
        <input type="text" className="form-control" value={apiKey} onChange={onChangeApiKey} />
      </div>
      <div className="mb-3">
        <label className="form-label">Billing Period</label>
        <select className="form-select" value={billingPeriod} onChange={onChangeBillingPeriod}>
          {
            Object.values(BillingPeriod).map(p => <option key={p} value={p}>{p}</option>)
          }
        </select>
      </div>
      <button type="button" className="btn btn-success" disabled={disabled()} onClick={onSaveItem}>Save</button>
      <button type="button" className="btn bg-danger-subtle text-danger ms-2" onClick={onCancel}>Cancel</button>
    </div>
  );
}

interface Props {
  instance: Instance,
  settings: InstanceSettings,
  onSave: (instance: Instance, settings: InstanceSettings) => void,
  onCancel: () => void
}

export { InstanceForm };